export const dvdTransferManagersContracts = {
  mainnet: '0xC81139e228DF816F31D9a164221a937b1015f0F2',
  homestead: '0xC81139e228DF816F31D9a164221a937b1015f0F2',
  matic: '0xD5B75190aF53Ff676d0b94014Ac607fD07C8B628',
  ropsten: '0x612f8AFbC048aa0A7e5C46fa7FC453Da3A51F10b',
  kovan: '0xa89a7c589D1bC0f38284dB9F1eB34F197E9Ad284',
  mumbai: '0x1bce7BdF1ace7A47FB0Dc14c31CAB3F2d86eFFB4',
  fuji: '0x346B13B63A657939370c5D883103FC3Dc5475A58',
  avax: '0x88546F73Ebb04Be9B7433e2158720D3FC067996f',
  klaytn: '0x10464FD78B988f596FbE3278874506Aa99C00F08',
  baobab: '0x10464FD78B988f596FbE3278874506Aa99C00F08',
  amoy: '0xcecE353c80DEade85Db9cb0bBf2297F27776b213',
  telos: '0x4e0F1f87259E1245c76d250d30038A33c77bFf02',
  telosTestnet: '0xcecE353c80DEade85Db9cb0bBf2297F27776b213',
};

export default {
  dvdTransferManagersContracts,
};
